module.exports = __webpack_public_path__ + "static/media/landing_time.d1684254.svg";